import type { Expense } from '../types';

function escapeCsv(value: string | number) {
  const stringValue = String(value).replace(/"/g, '""');
  return /[",\n]/.test(stringValue) ? `"${stringValue}"` : stringValue;
}

export function downloadExpensesCsv(expenses: Expense[]) {
  const headers = ['Date', 'Transaction type', 'Name', 'Amount', 'Category', 'Payment method', 'Notes', 'Sync status'];
  const rows = expenses
    .slice()
    .sort((a, b) => new Date(b.occurredAt).getTime() - new Date(a.occurredAt).getTime())
    .map((expense) => [
      new Date(expense.occurredAt).toLocaleString('en-IN'),
      expense.kind,
      expense.name,
      expense.amount,
      expense.category,
      expense.paymentMethod,
      expense.notes,
      expense.syncStatus,
    ].map(escapeCsv).join(','));
  const csv = `\uFEFF${headers.join(',')}\n${rows.join('\n')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `quickspend-expenses-${new Date().toISOString().slice(0, 10)}.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
}
